import React, { useEffect, useRef, useState } from "react";

/** Libraries */
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

/** Components */
import { fadeIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

/** style */
import "../../../Assets/scss/MedicalCounsellingIndia/pages/home.scss";
import CommonContactButton from "../../Components/AnotherButton/CommonContactButton";
import MetaTags from "../../Components/MetaTags";
import "./DirectAdmissionInBptInPune.scss";

/** top college details */

function MbaAdmissionConsultants() {
  const [formLoading, setFormLoading] = useState(false);
  const collegeSectionRef = useRef(null);
  const location = useLocation();

  // const collegeTitle = collegeName
  // .split("-")
  // .map((curElem) => {
  //   if (exceptions.includes(curElem)) return curElem;
  //   return curElem.charAt(0).toUpperCase() + curElem.slice(1);
  // })
  // .join(" ");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    console.log(data);
    setFormLoading(true);
    toast.success("Your message has been sent successfully!", {
      theme: "colored",
    });

    setTimeout(() => {
      setFormLoading(false);
    }, 1000);
  };

  const handleKeyDown = (event) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    const isNumberKey = !isNaN(Number(event.key)) && event.code !== "Space";

    if (!allowedKeys.includes(event.code) && !isNumberKey) {
      event.preventDefault();
    }
  };

  /** scroll to college */

  useEffect(() => {
    if (
      location.search.includes("scrollToCollege=true") &&
      collegeSectionRef.current
    ) {
      collegeSectionRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("hi");
    }
  }, [location.search]);

  return (
    <>
      <MetaTags
        title="Best MBA Admission Consultants in India – 2026 Admissions"
        description="Get expert advice from top MBA admission consultants in India for 2026. Secure direct admission in leading MBA colleges.   Call 9730858444 for help."
        keywords="top MBA consultants India, India MBA admission help, MBA career consultant, India B-school consultant, MBA direct admission expert"
      />

      {/* banner Parallax Scrolling End */}

      {/* instruction section start  */}
      <section className="bg-lightgray py-[150px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[100px]">
        <Container>
          {/* How to get Admission */}
          <div className="">
            <div>
              <div className="!text-[#616162] mt-4  ">
                <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-normal">
                  MBA Admission Consultants in India – Counselling India
                </h1>
                <div className="mt-3">
                  In a rapidly evolving global economy, an MBA has become more
                  than just a qualification — it is a gateway to leadership,
                  innovation, and entrepreneurship. With thousands of B-schools
                  across India offering various management programs, choosing
                  the right college and navigating the complex admission process
                  can be overwhelming. That’s where MBA Admission Consultants in
                  India like Counselling India step in to bridge the gap between
                  aspirations and successful admission.
                </div>
                <div>
                  With over 20 years of experience, Counselling India is one of
                  the most trusted names in the field of higher education
                  consultancy. We specialize in MBA admissions across India’s
                  top private and deemed universities through management quota,
                  direct admission, and NRI quota, offering students a
                  streamlined and personalized experience from start to finish.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <CommonContactButton />
          </div>

          {/* general eligibility */}

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Students Choose MBA Admission Consultants in India
            </h2>
            <div>
              <p className="!text-[#616162]">
                The MBA admission process is not as simple as filling a form and
                waiting for results. With increasing competition, strict
                entrance cutoffs, and limited seats in top B-schools, even
                deserving students face rejection. This is why more and more
                aspirants are turning to MBA Admission Consultants in India for
                professional guidance.
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <div>
                    <b>1. Complex Admission Proceduress</b>
                  </div>

                  <div>
                    From national-level entrance exams like CAT, MAT, XAT, and
                    NMAT to group discussions and personal interviews, the
                    process can be highly complicated and time-consuming. An
                    experienced consultant simplifies this for students.
                  </div>
                </li>
                <li className="mt-3">
                  <div>
                    <b>2. Lack of Information</b>
                  </div>

                  <div>
                    Not every student or parent knows about the vast options
                    available across cities like Pune, Bangalore, Mumbai, Delhi,
                    and Chennai. Consultants provide accurate, up-to-date
                    information about colleges, courses, fees, and
                    specializations.
                  </div>
                </li>
                <li className="mt-3">
                  <div>
                    <b>3. Direct and Management Quota Admissions</b>
                  </div>
                  <p>
                    For students who miss entrance exam cutoffs or prefer a
                    quicker route, MBA Admission Consultants in India help with
                    direct admission under management quota, often not openly
                    advertised by colleges.
                  </p>
                </li>
                <li className="mt-3">
                  <div>
                    <b>4. Time-Saving and Stress-Free</b>
                  </div>
                  <p>
                    With expert support, students avoid unnecessary delays,
                    confusion, and paperwork errors — ensuring a smoother
                    journey from application to admission.
                  </p>
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              About Counselling India – Trusted MBA Admissions Partner
            </h2>
            <div>
              <p className="!text-[#616162]">
                At Counselling India, we’ve helped thousands of students get
                admission into top MBA colleges across India. Our team of
                experienced consultants, career counselors, and education
                strategists work closely with students and parents to identify
                the best possible path based on their academic performance,
                career goals, and financial situation.
              </p>
              <p>
                As leading MBA Admission Consultants in India, we offer a
                one-stop solution for all your MBA admission needs — from
                profile evaluation to post-admission services.
              </p>
            </div>
            <div>
              <b>Our Services</b>
              <p>
                Here’s how Counselling India stands out among MBA Admission
                Consultants in India:
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b>1. Profile Evaluation & Career Counseling</b>
                  <p>
                    We begin by understanding your academic background, entrance
                    exam scores (if any), work experience, and future career
                    goals. This helps us tailor a list of colleges and programs
                    that align with your vision.
                  </p>
                </li>
                <li className="mt-2">
                  <b>2. College Shortlisting Across India</b>
                  <p>
                    We provide personalized recommendations from India’s top MBA
                    colleges based on:
                    <ol className="list-disc">
                      <li>Budget</li>
                      <li>Location preference</li>
                      <li>Specializations</li>
                      <li>Placement record</li>
                      <li>Campus culture and infrastructure</li>
                    </ol>
                    Our database includes premier institutions across
                    Maharashtra, Karnataka, Tamil Nadu, Delhi NCR, Telangana,
                    and more.
                  </p>
                </li>

                <li className="mt-2">
                  <b>3. Admission Through Management & NRI Quota</b>
                  <p>
                    For students seeking direct admission or missed entrance
                    test cutoffs, we offer:
                    <lo>
                      <li>MBA admission through management quota</li>
                      <li>Admission under NRI/sponsored quota</li>
                      <li>Spot admissions in selected institutions</li>
                      We have long-standing tie-ups with colleges in cities like
                      Pune, Bangalore, Mumbai, and Hyderabad, allowing us to
                      help you secure seats smoothly and ethically.
                    </lo>
                  </p>
                </li>
                <li className="mt-2">
                  <b>4. Entrance Exam Guidance (CAT, MAT, NMAT, XAT)</b>
                  <p>Our consultants guide students on:</p>
                  <div>
                    <lo className="list-disc">
                      <li>Exam timelines and registration</li>
                      <li>Choosing the right exam based on target colleges</li>
                      <li>
                        Minimum required scores for different institutions
                      </li>
                      <li>Backup options in case of low scores</li>
                    </lo>
                  </div>
                </li>
                <li className="mt-2">
                  <b>5. Application & Documentation Support</b>
                  <p>
                    We assist in compiling, reviewing, and submitting all
                    documents required by colleges, such as:
                    <ol>
                      <li>10th, 12th, and graduation mark sheets</li>
                      <li>Identity proof</li>
                      <li>Entrance exam scorecards </li>
                      <li>Passport-size photos</li>
                      <li>
                        SOP (Statement of Purpose) and LORs (Letters of
                        Recommendation) where applicable{" "}
                      </li>
                    </ol>
                  </p>
                </li>
                <li>
                  <b>6. Interview & GD Preparation</b>
                  <p>
                    For colleges that conduct personal interviews or group
                    discussions, we provide:
                    <ol>
                      <li>Mock interviews</li>
                      <li>GD training sessions</li>
                      <li>Personalized feedback</li>
                      <li>Soft skills and confidence-building</li>
                      This helps you stand out and make a lasting impression
                      during final selection
                    </ol>
                  </p>
                </li>

                <li className="mt-2">
                  <b>7. Post-Admission Assistance</b>
                  <p>
                    Our support doesn’t end with admission. We also help with:
                    <ol>
                      <li>Fee payment guidance</li>
                      <li>Hostel booking</li>
                      <li>Loan assistance referrals</li>
                      <li>Orientation and joining instructions</li>
                    </ol>
                  </p>
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Top MBA Colleges We Work With
            </h2>
            <p>
              As experienced MBA Admission Consultants in India, we help
              students gain admission into prestigious colleges such as:
            </p>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>
                    Symbiosis Institute of Business Management (Pune, Bangalore)
                  </b>
                </li>
                <li>
                  <b>NMIMS (Mumbai, Bangalore, Hyderabad)</b>
                </li>
                <li>
                  <b>Christ University (Bangalore)</b>
                </li>
                <li>
                  <b>Amity Business School (Noida, Mumbai)</b>
                </li>
                <li>
                  <b>ICFAI Business School (Hyderabad & Pan India) )</b>
                </li>
                <li>
                  <b>Jain University (Bangalore)</b>
                </li>
                <li>
                  <b>ICFAI Business School (Hyderabad and pan-India)</b>
                </li>
                <li>
                  <b>XIME (Bangalore)</b>
                </li>
                <li>
                  <b>MIT School of Management (Pune)</b>
                </li>
                <li>
                  <b>PES University (Bangalore)</b>
                </li>{" "}
                <li>
                  <b>ISME, IFIM, Ramaiah Institute of Management, and more)</b>
                </li>
              </ol>
              <p>
                We also assist with specialized MBA/PGDM programs in Business
                Analytics, Finance, HR, Marketing, Operations, International
                Business, and Healthcare Management.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Counselling India is the Right Choice
            </h2>
            <p>
              Among the many MBA Admission Consultants in India, Counselling
              India stands out for its ethical approach, transparency, and
              student-first mindset.
            </p>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>✅ 20+ Years of Expertise</b>

                  <p>
                    With decades of experience, we’ve developed deep insights
                    into admission trends, quotas, and college expectations.
                  </p>
                </li>
                <li>
                  <b>✅ Personalized & Ethical Guidance</b>
                  <p>
                    No one-size-fits-all solutions. Every student receives
                    customized advice — no fake promises or pushy marketing.
                  </p>
                </li>
                <li>
                  <b>✅ Strong College Network</b>
                  <p>
                    We have built strong professional relationships with
                    admissions departments of top private colleges across India.
                  </p>
                </li>
                <li>
                  <b>✅ 100% Confidentiality & Transparency</b>
                  <p>
                    All admissions are carried out through proper channels, with
                    complete transparency and official receipts.{" "}
                  </p>
                </li>{" "}
                <li>
                  <b>✅ Success Rate & Trust</b>
                  <p>
                    Thousands of students have successfully secured their MBA
                    seats through our guidance — and many return to us for
                    further academic or career support.{" "}
                  </p>
                </li>
              </ol>

              <p className="mt-3">
                At <b>Counselling India,</b> we demystify this process and
                ensure fair and quick admission to deserving students through
                this route.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Testimonials
            </h2>
            <p className="w-50">
              “Counselling India helped me get admission into a top B-school in
              Bangalore even though my CAT score was below average. The entire
              process was smooth and transparent. Highly recommended MBA
              consultants.”
              <b className="fst-italic">— Sneha R., Pune</b>
            </p>

            <p className="mt-5 w-50">
              “I didn’t know much about management quota admissions until I
              found Counselling India. They guided me for MBA in Finance at a
              reputed college in Mumbai. Honest and professional consultants.”
              <b className="fst-italic"> — Vikram T., Delhi</b>
            </p>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Who Can Approach Us?
            </h2>
            <p>Our services are perfect for:</p>
            <ol>
              <li>Fresh graduates seeking MBA admission in 2026</li>
              <li>Working professionals applying for Executive MBA</li>
              <li>
                Parents looking for safe and reliable admission options for
                their children
              </li>
              <li>NRI students exploring Indian MBA programs</li>
              <li>
                Students seeking admission without high entrance exam scores
              </li>
            </ol>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Final Thoughts
            </h2>
          </div>

          <div>
            In today’s competitive education environment, choosing the right
            consultant can be the key to securing your MBA dream. At Counselling
            India, we are committed to providing expert, honest, and timely
            support for every student we serve. As one of the most dependable
            MBA Admission Consultants in India, we take pride in turning career
            dreams into academic realities.
          </div>
          <div>
            If you’re looking for hassle-free MBA admissions, ethical
            consulting, and top-college access across India, Counselling India
            is the name you can trust.
          </div>

          <div className="mt-5">
            <hr className="mb-2" />

            <b>Ready to begin your MBA journey?</b>
            <p>
              {" "}
              Connect with Counselling India today and let our expert MBA
              admissions consultants help you take the next step toward a
              successful future.{" "}
            </p>
          </div>

          <div className="mt-[50px]">
            <h2>FAQ’S</h2>

            <h6 className="mt-6">
              ❓ FAQ 1: Who are MBA Admission Consultants in India? MBA
              Admission Consultants in India
            </h6>
            <p>
              specialized agencies that help students secure admission to top
              MBA colleges across the country. They provide end-to-end guidance
              — from shortlisting the right B-schools to helping with entrance
              exam strategies, SOP (Statement of Purpose) writing, essay
              drafting, interview preparation, and even exploring management
              quota seats if needed. Many students approach MBA Admission
              Consultants in India because the MBA admission process can be
              complex and competitive, with multiple entrance exams, strict
              deadlines, and tough selection rounds. These consultants have deep
              insights into the admission trends of leading Indian B-schools
              like IIMs, XLRI, SPJIMR, Symbiosis, NMIMS, and more. MBA Admission
              Consultants in India also maintain strong networks with colleges
              to get updated information on seat availability, cut-offs, and
              management quota options. Their personalized support helps
              students avoid mistakes, submit strong applications, and secure
              their dream MBA seat confidently.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 2: Why do students choose MBA Admission Consultants in
              India?
            </h6>
            <p>
              Many students choose MBA Admission Consultants in India to reduce
              stress, save time, and increase their chances of getting into top
              B-schools. The admission process in India can be overwhelming —
              with multiple exams like CAT, XAT, SNAP, NMAT, and CMAT, different
              application forms, and tight deadlines. MBA Admission Consultants
              in India provide clarity by helping students understand which
              exams to attempt, which colleges to target, and how to build a
              standout profile. They assist in drafting compelling SOPs and
              essays, preparing for GD/PI rounds, and staying on track with
              deadlines. Some students also rely on MBA Admission Consultants in
              India to explore options like direct admission through management
              quota when scores are below the cut-off. By offering personalized
              attention, mock interviews, and genuine advice, good MBA Admission
              Consultants in India ensure that students have a smoother journey
              from preparation to final admission.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 3: What services do MBA Admission Consultants in India
              offer?
            </h6>
            <p>
              MBA Admission Consultants in India offer a wide range of services
              tailored to a student’s unique profile. This usually starts with a
              detailed profile evaluation to identify strengths, weaknesses, and
              best-fit colleges. They help students shortlist B-schools based on
              entrance exam scores, career goals, and budget. Many MBA Admission
              Consultants in India also provide entrance exam coaching
              strategies or connect students with trusted coaching partners.
              They assist with crafting impressive SOPs, essays, and Letters of
              Recommendation (LORs), which are critical for admission success.
              Another key service is mock GD/PI sessions to prepare students for
              final interviews. Some MBA Admission Consultants in India also
              guide students about securing seats through management quota in
              reputed private colleges. From filling out applications correctly
              to organizing documents and following up with colleges, MBA
              Admission Consultants in India act as a reliable partner
              throughout the entire admission journey.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 4: How much do MBA Admission Consultants in India charge?
            </h6>
            <p>
              The fees for MBA Admission Consultants in India vary depending on
              the consultant’s reputation, services offered, and the number of
              colleges you’re applying to. For standard domestic MBA admissions,
              fees can range from ₹20,000 to ₹1 lakh or more. This might cover
              profile evaluation, SOP and essay drafting, application support,
              interview training, and general counseling. For students seeking
              multiple B-school applications or special support for management
              quota seats, the fee may be slightly higher. Some MBA Admission
              Consultants in India also provide packages that include end-to-end
              support until you receive your admission letter. It’s important to
              clarify the fee structure upfront and ensure that there are no
              hidden charges. Reputed MBA Admission Consultants in India will
              always offer clear payment terms, provide receipts for every
              transaction, and stick to a written agreement outlining services
              included in their package
            </p>
            <h6 className="mt-5">
              ❓ FAQ 5: Can MBA Admission Consultants in India help with low
              entrance scores?
            </h6>
            <p>
              Yes, experienced MBA Admission Consultants in India often help
              students with lower entrance scores find good alternatives to
              secure admission. Not all students hit the high cut-offs of top
              IIMs or XLRI on their first attempt. A professional MBA Admission
              Consultant in India can guide you to shortlist colleges with
              realistic cut-offs or explore institutes that accept multiple
              entrance exams like MAT or CMAT. Many MBA Admission Consultants in
              India also assist with direct admissions through management quota
              in reputed private colleges, ensuring you don’t lose an academic
              year due to low scores. They can also suggest options like
              retaking entrance exams, improving your SOPs, or strengthening
              your profile with short-term certifications and internships. A
              trusted MBA Admission Consultant in India
            </p>
          </div>
        </Container>
      </section>

      {/* instruction section start  */}

      {/* top college details start*/}

      {/* enquiry form section start */}
      <m.section
        className="py-[160px] bg-cover 	bg-no-repeat overflow-hidden relative bg-center lg:py-[120px] md:py-[95px] xs:py-[80px] xxs:py-[50px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/MedicalCounsellingIndia/home/enquiry/enquiry.webp)",
        }}
        {...fadeIn}
      >
        <Container className="xs:px-0">
          <div className="flex justify-center mb-[100px] w-full">
            <p className="font-normal text-[20px] w-[70%] lg:w-[70%] md:w-[100%] text-center">
              Get Top Education Consultant in Jamshedpur. Kindly submit your
              data below and we shall connect you as soon as possible.
            </p>
          </div>
          <Row className="justify-end md:justify-center">
            <Col xl={7} lg={7} md={9} sm={11}>
              <div className="px-[3rem] py-[5rem] rounded-md shadow-[0_0_30px_rgb(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-[6rem]">
                <span className="mb-[15px] font-medium text-center text-[#f78c1f] text-md font-serif uppercase block sm:mb-[10px]">
                  Submit your details here
                </span>
                <h5 className="w-[80%] mb-[40px] font-bold text-center	tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                  YOU ARE JUST A CALL AWAY
                </h5>

                <form className="mb-[30px]" onSubmit={handleSubmit(onSubmit)}>
                  <m.div
                    className="row justify-center"
                    {...{ ...fadeIn, transition: { delay: 0.6 } }}
                  >
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="name"
                          className="rounded-[5px] relative py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.name?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="email"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your email address"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                              message: "Enter valid email",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.email?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="number"
                          name="phone"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your phone number"
                          onKeyDown={handleKeyDown}
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "Phone number is required",
                            },
                            pattern: {
                              value:
                                /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                              message: "Enter valid phone number",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.phone?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="address"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your address"
                          {...register("address", {
                            required: {
                              value: true,
                              message: "Address is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.address?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="stream"
                          className="rounded-[5px] py-[13px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Subject"
                          {...register("stream", {
                            required: {
                              value: true,
                              message: "Stream is required",
                            },
                            value: "Subject",
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.stream?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <textarea
                          type="text"
                          rows={3}
                          name="message"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your message"
                          {...register("message", {
                            required: {
                              value: true,
                              message: "Message is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-10px] translate-x-[10px]">
                          {errors.message?.message}
                        </div>
                      </div>
                    </Col>
                  </m.div>

                  <Buttons
                    type="submit"
                    className={`btn-fill text-sm leading-none font-medium tracking-[1px] !py-[17px] px-[32px] rounded-[4px] w-full uppercase mb-[5px] ${
                      formLoading ? "loading" : ""
                    }`}
                    themeColor="#f78c1f"
                    color="#fff"
                    size="lg"
                    title="Request a call schedule"
                  />
                </form>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </m.section>
      {/* enquiry form section end */}
    </>
  );
}

export default MbaAdmissionConsultants;
